import { Avatar, Box, Button, Card, CardBody, CardHeader, Flex, Grid, Icon, Text, useColorModeValue } from '@chakra-ui/react'
import React from 'react'
import { MdOutlineSecurity, MdSettings } from 'react-icons/md'
import { ImProfile } from 'react-icons/im'
import { IoMdMale, IoMdFemale } from 'react-icons/io'
import { useStateContext } from '../../context/ContextProvider'
import { linkImage } from '../../axios-client';
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
function Profil() {
    const { user } = useStateContext();
    const navigate = useNavigate()
    const { t } = useTranslation();

    const cardBg = useColorModeValue("white", "gray.800");
    const labelColor = useColorModeValue("gray.400", "gray.500");
    const valueColor = useColorModeValue("gray.700", "gray.200");
    const subtleBg = useColorModeValue("gray.50", "gray.700");

    const InfoRow = ({ label, value, placeholder }) => (
        <Flex
            mb={3}
            flexDirection={{ base: "column", md: "row" }}
            align={{ base: "flex-start", md: "center" }}
            py={2.5}
            px={3}
            borderRadius="10px"
            bg={subtleBg}
        >
            <Text
                w={{ base: "100%", md: "35%" }}
                fontSize="13px"
                fontWeight="600"
                color={labelColor}
                letterSpacing="0.02em"
                mb={{ base: 1, md: 0 }}
            >
                {label}
            </Text>
            <Text fontSize="14px" color={valueColor} fontWeight="500">
                {value || <span style={{ color: '#a0aec0', fontStyle: 'italic', fontWeight: 400 }}>{placeholder || t("non disponibles.")}</span>}
            </Text>
        </Flex>
    );

    return (
        <Box className="animate-fade-up">
            <Flex direction='column' mt={{ sm: '25px', md: '0px' }}>
                <Flex
                    mb={{ base: "20px", sm: '24px', md: '40px', xl: '20px' }}
                    borderRadius='16px'
                    px='0px'
                    display='flex'
                    flexDirection='column'
                    justifyContent='center'
                    align='center'>
                    {/* Header */}
                    <Flex
                        direction={{ base: "column", sm: 'column', md: 'row' }}
                        mx='auto'
                        maxH='330px'
                        w={{ sm: '90%', xl: '100%' }}
                        justifyContent={{ sm: 'center', md: 'space-between' }}
                        align='center'
                        p='24px'
                        borderRadius='16px'
                        bg={cardBg}
                        border="1px solid"
                        borderColor={useColorModeValue("gray.100", "gray.700")}
                        boxShadow="0 1px 3px rgba(0,0,0,0.04)"
                        mt='10px'>
                        <Flex
                            align='center'
                            mb={{ sm: '10px', md: '10px' }}
                            direction={{ sm: 'column', md: 'row' }}
                            w={{ sm: '100%' }}
                            textAlign={{ sm: 'center', md: 'start' }}>
                            <Avatar
                                me={{ md: '22px' }}
                                mr={{ base: 5, sm: 0, md: 5 }}
                                src={linkImage + user?.image}
                                w={{ base: "70px", md: "80px" }}
                                h={{ base: "70px", md: "80px" }}
                                borderRadius='16px'
                                border="3px solid"
                                borderColor={useColorModeValue("purple.100", "purple.700")}
                            >
                            </Avatar>
                            <Flex direction='column' maxWidth='100%' my={{ sm: '14px' }}>
                                <Flex direction='row' align={'center'}>
                                    <Text
                                        fontSize={{ sm: 'lg', lg: 'xl' }}
                                        color={useColorModeValue("gray.700", "white")}
                                        fontWeight='700'
                                        letterSpacing="-0.02em"
                                        ms={{ sm: '8px', md: '0px' }}
                                        mr={2}
                                    >
                                        {user.first_name} {user.last_name}
                                    </Text>
                                    {user.gender === "Femme" ? <IoMdFemale size={"22px"} color='#ff8096' /> : user.gender === "Homme" ? <IoMdMale size={"22px"} color='#5da4ff' /> : null}
                                </Flex>

                                <Text fontSize='14px' color={useColorModeValue('gray.400', 'gray.400')} fontWeight="400">
                                    {user.email}
                                </Text>
                            </Flex>
                        </Flex>
                        <Flex direction={{ base: 'column', lg: 'row' }} mt={{ base: 2, md: 0 }} w={{ sm: '100%', md: '50%', lg: 'auto' }} gap={2}>
                            <Button
                                onClick={() => navigate('/profil')}
                                borderRadius='10px'
                                size="sm"
                                bg="linear-gradient(135deg, #7B5EA7 0%, #9F7AEA 100%)"
                                color="white"
                                _hover={{
                                    bg: "linear-gradient(135deg, #6B4E97 0%, #8F6ADA 100%)",
                                    transform: "translateY(-1px)",
                                }}
                                leftIcon={<Icon as={ImProfile} />}>
                                <Text fontSize='13px' fontWeight='600'>
                                    {t("PROFIL")}
                                </Text>
                            </Button>
                            <Button
                                borderRadius='10px'
                                size="sm"
                                variant="ghost"
                                onClick={() => navigate('/modifier-profil')}
                                leftIcon={<Icon color={useColorModeValue("gray.600", "gray.300")} as={MdSettings} />}>
                                <Text fontSize='13px' color={useColorModeValue("gray.600", "gray.300")} fontWeight='600'>
                                    {t("PARAMÈTRE")}
                                </Text>
                            </Button>
                            <Button
                                borderRadius='10px'
                                size="sm"
                                variant="ghost"
                                onClick={() => navigate('/securite-de-compte')}
                                leftIcon={<Icon color={useColorModeValue("gray.600", "gray.300")} as={MdOutlineSecurity} />}>
                                <Text fontSize='13px' color={useColorModeValue("gray.600", "gray.300")} fontWeight='600'>
                                    {t("SÉCURITÉ DE COMPTE")}
                                </Text>
                            </Button>
                        </Flex>
                    </Flex>
                </Flex>
                <Grid px={5} templateColumns={{ sm: "1fr", md: "1fr", lg: "3fr 2fr " }} justify={"center"} gap='22px'>

                    <Card
                        rounded={"16px"}
                        bg={cardBg}
                        border="1px solid"
                        borderColor={useColorModeValue("gray.100", "gray.700")}
                        boxShadow="0 1px 3px rgba(0,0,0,0.04)"
                        display={'flex'}
                        p='20px'
                    >
                        <CardHeader p='5px 5px' mb='12px'>
                            <Text fontSize='16px' color={useColorModeValue("gray.700", "white")} fontWeight='700' letterSpacing="-0.02em">
                                {t("Informations de profil")}
                            </Text>
                        </CardHeader>
                        <CardBody px='5px' pt={0}>
                            <Flex direction='column'>
                                <InfoRow label={t("Nom complet")} value={`${user.first_name} ${user.last_name}`} />
                                <InfoRow label={t("Adresse email")} value={user.email} />
                                <InfoRow label={t("Téléphone")} value={user.tel} placeholder={t("Téléphone non disponibles")} />
                                <InfoRow label={t("Date de naissance")} value={user.birthday ? new Date(user.birthday).toLocaleDateString(t('fr-Fr')) : null} placeholder={t("Date non disponibles")} />
                            </Flex>
                        </CardBody>
                    </Card>
                    <Card
                        rounded={"16px"}
                        bg={cardBg}
                        border="1px solid"
                        borderColor={useColorModeValue("gray.100", "gray.700")}
                        boxShadow="0 1px 3px rgba(0,0,0,0.04)"
                        display={'flex'}
                        p='20px'
                    >
                        <CardHeader p='5px 5px' mb='12px'>
                            <Text fontSize='16px' fontWeight='700' letterSpacing="-0.02em">
                                {t("Adresse")}
                            </Text>
                        </CardHeader>
                        <CardBody px='5px' pt={0}>
                            <Flex direction='column'>
                                <InfoRow label={t("Rue")} value={user.rue} />
                                <InfoRow label={t("Ville")} value={user.ville} />
                                <InfoRow label={t("Pays")} value={user.pays} />
                                <InfoRow label={t("Code postal")} value={user.code_postal} />
                            </Flex>
                        </CardBody>
                    </Card>

                </Grid>
            </Flex>
        </Box>

    )
}

export default Profil